import axios from "axios";
import { extractError, normalizeError } from "../../utils/apiErrorUtils";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

// Returns full wishlist items with populated card data. `cfg` goes to axios;
// `{ quiet: true }` keeps a background reload out of the global snackbar.
export const fetchWishlist = async (cfg) => {
  try {
    const { data } = await axios.get(`${apiUrl}/wishlist`, cfg);
    return data;
  } catch (error) {
    return Promise.reject(extractError(error, "Failed to fetch wishlist"));
  }
};

// Returns array of card ID strings — light call used for checking per-card heart state
export const fetchWishlistIds = async () => {
  try {
    const { data } = await axios.get(`${apiUrl}/wishlist/ids`);
    return data;
  } catch (error) {
    return Promise.reject(extractError(error, "Failed to fetch wishlist IDs"));
  }
};

export const addToWishlist = async (cardId) => {
  try {
    const { data } = await axios.post(`${apiUrl}/wishlist/${cardId}`);
    return data;
  } catch (error) {
    return Promise.reject(extractError(error, "Failed to add to wishlist"));
  }
};

export const removeFromWishlist = async (cardId) => {
  try {
    const { data } = await axios.delete(`${apiUrl}/wishlist/${cardId}`);
    return data;
  } catch (error) {
    return Promise.reject(extractError(error, "Failed to remove from wishlist"));
  }
};

export const addBulkToWishlist = async (cardIds) => {
  try {
    const { data } = await axios.post(`${apiUrl}/wishlist/batch`, { cardIds });
    return data;
  } catch (error) {
    return Promise.reject(extractError(error, "Failed to add cards to wishlist"));
  }
};

export const getWishlistMatches = async (lng, lat, radius = 50000) => {
  try {
    const { data } = await axios.get(
      `${apiUrl}/wishlist/matches?lng=${lng}&lat=${lat}&radius=${radius}`,
      // quietForbidden: the 403 launch-area refusal is shown in place by the
      // map, so it gets no toast on top (E2E audit 15·9c); an outage still
      // does, because not every map state shows it (release review).
      { quietForbidden: true }
    );
    return data;
  } catch (error) {
    // Rejects with { message, status, retryable } rather than a bare string:
    // the map must tell a 429 apart from a network failure to render an
    // honest empty state (#82).
    return Promise.reject(normalizeError(error, "Failed to get wishlist matches"));
  }
};
